module.exports = __webpack_public_path__ + "img/get-inspired.fcc88f70.svg";